import React, { useEffect, useState } from "react";
import { VehicleCategoryDropdownProps } from "./types";

import { DropdownOption } from "../Dropdown/types";
import { getFleetSettingsAPI } from "services/api/settings/fleet/api";
import { FleetSettingVehicleCategory } from "services/api/settings/fleet/types";
import Dropdown from "../Dropdown/Dropdown";

const VehicleCategoryDropdown: React.FC<VehicleCategoryDropdownProps> = (
  props: VehicleCategoryDropdownProps
) => {
  const {
    name,
    disabled,
    required,
    label,
    error,
    value,
    direction,
    width,
    height,
    placeholder,
    onChange,
  } = props;

  const [categories, setCategories] = useState<FleetSettingVehicleCategory[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const result = await getFleetSettingsAPI();
        setCategories(result.selectedVehicleCategories);
      } catch {
        return;
      }
    };
    fetchCategories();
  }, []);

  const categoryOptions: DropdownOption[] = [...categories]
    .sort((a, b) => a.id.localeCompare(b.id))
    .map((c) => ({
      value: c.id,
      text: c.name,
    }));

  if (categories.length <= 1) return null;

  return (
    <Dropdown
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      value={value}
      direction={direction}
      width={width}
      height={height}
      options={categoryOptions}
      onChange={onChange}
      error={error}
    />
  );
};

export default React.memo(VehicleCategoryDropdown);
